import { useCarrierScorecardInfoLazyQuery } from '../graphql/CarrierScorecardInfo'
import { TCarrierScoreInfo } from '../graphql/types'

interface IUseCarrierScoreDataResult {
  item: TCarrierScoreInfo | null
  loadCarrierScoreData: (carrierId: string) => void
}

export const useCarrierScoreData = (): IUseCarrierScoreDataResult => {
  const [getData, { data }] = useCarrierScorecardInfoLazyQuery({})

  const { carrierApplication: element } = data || {}
  const { carrierScorecard } = element || {}
  const item = carrierScorecard?.stale ? null : carrierScorecard

  const loadCarrierScoreData = (carrierId: string) => {
    if (carrierId) {
      getData({
        variables: {
          id: carrierId,
        },
      })
    }
  }

  return {
    item,
    loadCarrierScoreData,
  }
}
